import type { CopilotOverlayStore } from '@/shared/stores/ui';

import type { ProposedAction } from '@/entities/proposed-actions';
import type { SourceProposedActionT } from '@/shared/lib';

export interface DosespotActionPrefill {
  action: ProposedAction;
  sourceProposedAction?: SourceProposedActionT;
}

declare module '@/shared/stores/ui/copilotOverlay' {
  interface CopilotOverlayPayloads {
    dosespotAction: DosespotActionPrefill;
  }
}

/**
 * Open the DoseSpot action wizard with its payload.
 */
export function openDosespotActionOverlay(
  overlays: CopilotOverlayStore,
  prefill: DosespotActionPrefill
): void {
  overlays.open('dosespotAction', prefill);
}
